import { getApiClient, getVantageApiClient } from '@sophocles/axiosInit';

export const apiClient = getApiClient();
export const vantageApiClient = getVantageApiClient();
export default apiClient;

// import axios from 'axios';

// import { refreshToken } from '@sophocles/features/auth/authActions';
// // eslint-disable-next-line import/no-unresolved
// import { API_URL, VANTAGE_API_URL } from '@sophocles/config';
// import { getSocketIdSelector } from '@sophocles/notifyApp/notifySelectors';
// import tokenService from '@sophocles/services/token';
// import store from '@sophocles/store/redux-store';

// export function getHeaders() {
//   const headers = {};

//   const { pool, idToken, isImpersonating, impersonationToken } = tokenService;
//   if (pool) {
//     headers['X-Pool-ID'] = pool;
//   }

//   if (idToken) {
//     if (isImpersonating && impersonationToken != null) {
//       headers.Authorization = `Token ${impersonationToken}`;
//     } else if (!pool) {
//       headers.Authorization = `Token ${idToken}`;
//     } else {
//       headers.Authorization = `Bearer ${idToken}`;
//     }
//   }

//   return headers;
// }

// const setupAxiosInterceptors = options => {
//   const client = axios.create({
//     baseURL: options.baseURL ? options.baseURL : API_URL,
//     headers: {
//       Accept: 'application/json',
//       'Content-type': 'application/json',
//     },
//     responseType: 'json',
//   });

//   client.interceptors.request.use(
//     config => {
//       const { pool, idToken, isImpersonating, impersonationToken } = tokenService;

//       if (pool) {
//         config.headers['X-Pool-ID'] = pool;
//       }

//       if (options.socketId) {
//         config.headers['Socket-ID'] = options.socketId();
//       }

//       if (idToken) {
//         if (isImpersonating && impersonationToken != null) {
//           config.headers.Authorization = `Token ${impersonationToken}`;
//         } else if (!pool) {
//           config.headers.Authorization = `Token ${idToken}`;
//         } else {
//           config.headers.Authorization = `Bearer ${idToken}`;
//         }
//       }

//       return config;
//     },
//     error => {
//       return Promise.reject(error);
//     },
//   );

//   client.interceptors.response.use(
//     response => {
//       return response;
//     },
//     async error => {
//       const originalRequest = error.config;
//       switch (error.response.status) {
//         case 403:
//           if (error.config.url.includes('/auth/refresh')) {
//             return Promise.reject(error);
//           }
//           if (tokenService.refreshToken && tokenService.refreshToken != 'undefined') {
//             if (!originalRequest._retry) {
//               originalRequest._retry = true;
//               tokenService.idToken = null;
//               await options.onUnauthenticated();
//               return client(originalRequest);
//             }
//           }

//           if (error.config.url.includes('/users/me') && !window.location.href.indexOf('/login') > -1) {
//             tokenService.logout();
//             window.location.href = '/login';
//           }

//           return Promise.reject(error);
//         default:
//           return Promise.reject(error);
//       }
//     },
//   );

//   return client;
// };

// const apiClient = setupAxiosInterceptors({
//   onUnauthenticated: () => store.dispatch(refreshToken()),
//   socketId: () => getSocketIdSelector(store.getState()),
// });

// export const vantageApiClient = setupAxiosInterceptors({
//   baseURL: VANTAGE_API_URL,
//   onUnauthenticated: () => store.dispatch(refreshToken()),
//   socketId: () => getSocketIdSelector(store.getState()),
// });

// export default apiClient;
